import { WerkeAuswahlTableCell } from './WerkeAuswahlTableCell';
import { WerkeAuswahlListEntry } from './WerkeAuswahlListEntry';

const WerkeEntry = {
    Cell: WerkeAuswahlTableCell,
    List: WerkeAuswahlListEntry,
};

export { WerkeEntry };
